import { Theme as e } from "../ThemeContext.js";
import { useMatchMedia as t } from "../../../hooks/useMatchMedia.js";
import "../../../hooks/index.js";
import { ThemeProvider as n } from "../ThemeProvider/ThemeProvider.js";
import { c as r } from "react/compiler-runtime";
import { useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/Theme/ThemeSyncWithSystemProvider/ThemeSyncWithSystemProvider.tsx
var o = "(prefers-color-scheme: dark)", s = (s) => {
	let c = r(10), { children: l, initialTheme: u, getTheme: d, saveTheme: f } = s, p = u === void 0 ? e.auto : u, m = t(o) ? e.dark : e.light, h;
	c[0] !== d || c[1] !== p ? (h = () => d() || p, c[0] = d, c[1] = p, c[2] = h) : h = c[2];
	let [g, _] = i(h), v;
	c[3] === f ? v = c[4] : (v = (e) => {
		f(e), _(e);
	}, c[3] = f, c[4] = v);
	let y = v, b;
	return c[5] !== l || c[6] !== y || c[7] !== m || c[8] !== g ? (b = /* @__PURE__ */ a(n, {
		onThemeChange: y,
		theme: g,
		systemTheme: m,
		children: l
	}), c[5] = l, c[6] = y, c[7] = m, c[8] = g, c[9] = b) : b = c[9], b;
};
//#endregion
export { s as ThemeSyncWithSystemProvider };
